<script setup lang="ts">
/**
 * 11/12/13-kayit-* ucundeki ust ilerleme cubugu ("Kimlik | Doğrulama |
 * Parola") — onayli PNG'lerin ucunde de gorunen paylasilan parca (bkz.
 * auth__11/12/13-kayit-*.png): mevcut adime kadarki segmentler dolu/mavi,
 * SONRAKI segmentler gri/bos. Ucu adim da AYNI 3 rotayi (register/
 * register-otp/register-password) sabit sirayla gosterdigi icin tek,
 * kucuk bir bilesende (brief'teki gibi HER view kendi kopyasini yazmasin).
 */
import { computed } from 'vue'

const props = defineProps<{
  current: 'identity' | 'otp' | 'password'
  labels: Readonly<Record<'identity' | 'otp' | 'password', string>>
}>()

const STEP_ORDER = ['identity', 'otp', 'password'] as const

const currentIndex = computed(() => STEP_ORDER.indexOf(props.current))

const steps = computed(() =>
  STEP_ORDER.map((step, index) => ({
    key: step,
    label: props.labels[step],
    active: index === currentIndex.value,
    done: index < currentIndex.value,
  })),
)
</script>

<template>
  <ol
    class="fw-register-steps"
    data-testid="register-steps"
  >
    <li
      v-for="step in steps"
      :key="step.key"
      class="fw-register-steps__item"
      :class="{
        'fw-register-steps__item--active': step.active,
        'fw-register-steps__item--done': step.done,
      }"
      :data-testid="`register-step-${step.key}`"
      :aria-current="step.active ? 'step' : undefined"
    >
      <span
        class="fw-register-steps__bar"
        aria-hidden="true"
      />
      <span class="fw-register-steps__label">{{ step.label }}</span>
    </li>
  </ol>
</template>

<style scoped>
.fw-register-steps {
  display: flex;
  gap: 10px;
  list-style: none;
  margin: 0 0 28px;
  padding: 0;
}

.fw-register-steps__item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}

.fw-register-steps__bar {
  height: 3px;
  border-radius: 3px;
  background: var(--fw-border);
}

.fw-register-steps__item--active .fw-register-steps__bar,
.fw-register-steps__item--done .fw-register-steps__bar {
  background: var(--fw-primary);
}

.fw-register-steps__label {
  font-size: 12px;
  color: var(--fw-text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fw-register-steps__item--done .fw-register-steps__label {
  color: var(--fw-text-secondary);
}

.fw-register-steps__item--active .fw-register-steps__label {
  color: var(--fw-text-primary);
  font-weight: 600;
}
</style>
